
Checkout.Payment.PayPalRequest = function(checkout, payment) {
	var paypalrequest = this;

	this.label = 'PayPal Request';

	this.$tpl = $('#payment-method-paypalrequest-tpl');
	this.$wrap = false;

	this.init = function() {

		if (payment.$methodContainer.find('div[data-method=paypalrequest]').length) {
			paypalrequest.addError = 'Only One PayPal Request Payment allowed per Order';
			return;
		}

		paypalrequest.$wrap = paypalrequest.$tpl
			.clone(true)
			.removeAttr('id');
	};

	this.getData = function() {
		return {};
	};

	this.init();
};

